import Helmet from "react-helmet";
import React from "react";
import {useIntl} from "react-intl";

const TagGenerator = ({page}) => {
  const intl = useIntl();

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{intl.formatMessage({ id: `meta-${page}-title` })}</title>
      <meta name="title" content={intl.formatMessage({ id: `meta-${page}-title` })} />
      <meta name="description" content={intl.formatMessage({ id: `meta-${page}-description` })} />
      <meta name="keywords" content={intl.formatMessage({ id: `meta-${page}-keywords` })} />
      <meta property="og:title" content={intl.formatMessage({ id: `meta-${page}-title` })} />
      <meta property="og:description" content={intl.formatMessage({ id: `meta-${page}-description` })} />
      <meta property="twitter:title" content={intl.formatMessage({ id: `meta-${page}-title` })} />
      <meta property="twitter:description" content={intl.formatMessage({ id: `meta-${page}-description` })} />
    </Helmet>
  );
}

export default TagGenerator;
